<script lang="typescript">
  import { scale } from "svelte/transition";
  import SelectedDay from "./SelectedDay.svelte";
  import DayInGrid from "./DayInGrid.svelte";
  import Panel from "../common/Panel.svelte";
  import { selectDay, service } from "./store";
  import type { Context } from "./store";
  import type { Week } from "./customer-calendar-types";

  const send = $service.send;
  let context: Context;
  $: context = $service.context;
  $: month = context.calendar.month;
  $: weekdays = context.calendar.weekday_names;
  let weeks: Array<Week>;
  $: weeks = context.calendar.weeks;
  $: error = context.error;

  const previousMonth = () => send("previous_month");
  const nextMonth = () => send("next_month");
  const refreshCurrentMonth = () => send("current_month");
  const closeSelectedDay = () => send("close_day");
  $: current = $service.machine.current;
  $: isLoadingMonth = current == "loading_month";
  $: isError = error != null;
  $: selectedDay = context.selectedDay;
  $: showNavigation = selectedDay == undefined;
  $: isDaySelected = selectedDay != undefined;
</script>

<div>
  <div class="customer-calendar">
    {#if isError}
      <Panel type="error">
        <pre>
      {error}
      </pre>
      </Panel>
    {/if}

    <div
      on:click={closeSelectedDay}
      class:dayselected={isDaySelected}
      class="header"
    >
      <div class="month">
        <h1>{month.month_name} {month.year}</h1>
      </div>
      {#if showNavigation}
        <div class:disabled={isLoadingMonth} class="calendar-navigation">
          <h1>
            <span class="arrow arrow-left" on:click={previousMonth}>
              <i class="arrow fas fa-chevron-left" />
            </span>
            <span class="refresh" on:click={refreshCurrentMonth}>
              {#if isLoadingMonth}
                <i class="fas fa-sync fa-spin" />
              {:else}
                <i class="arrow fas fa-sync" />
              {/if}
            </span>
            <span class="arrow arrow-right" on:click={nextMonth}>
              <i class="arrow fas fa-chevron-right" />
            </span>
          </h1>
        </div>
      {/if}
    </div>

    {#if selectedDay}
      <div in:scale>
        <SelectedDay day={selectedDay} />
      </div>
    {:else}
      <div class="calendar-grid">
        <div class="week-number heading"><h2>vko</h2></div>
        {#each weekdays as weekday}
          <div class="day-cell heading">
            <h2>
              {weekday}
            </h2>
          </div>
        {/each}
        {#each weeks as week (week.week_number)}
          <div class="week-number">
            <h2>{week.week_number}</h2>
          </div>
          {#each week.days as day (day.day)}
            <div
              class="day-cell"
              on:click={() => selectDay(day)}
              class:current={day.is_current_day}
            >
              <div>
                <DayInGrid {day} />
              </div>
            </div>
          {/each}
        {/each}
      </div>
    {/if}
  </div>
</div>

<style>
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .header.dayselected {
    cursor: pointer;
  }

  .calendar-navigation .arrow {
    cursor: pointer;
  }

  .calendar-navigation.disabled .arrow {
    cursor: default;
  }

  .calendar-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .week-number {
    min-width: 5%;
    max-width: 5%;
  }

  .day-cell {
    min-width: 13.57%;
    max-width: 13.57%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .day-cell > div {
    height: 100%;
  }

  .week-number {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
